export default "__VITE_ASSET__CDPitCai__"